import React from 'react';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomTypography from 'components/Fileds/CustomTypography';
import * as Yup from 'yup';
import GenericDialog from '../GenericDialog/GenericDialog';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import CustomTextArea from 'components/Fileds/CustomTextArea';
import CustomAutocomplete from 'components/Fileds/CustomAutocomplete';
import AddIcon from '@mui/icons-material/Add';

const AddStationWithChefsSchema = Yup.object().shape({
    name: Yup.string().required('Station Name is required'),
    chefs: Yup.array().of(Yup.number()).min(1, 'At least one chef is required'),
});

const AddStationWithChefsModal = ({ open, onClose, onSubmit, loading, chefOptions = [], initialValues: customInitialValues, onAddChef }) => {
    const theme = useTheme();

    return (
        <GenericDialog
            open={open}
            onClose={onClose}
            title="Add Station & Assign Chefs"
            initialValues={customInitialValues || {
                name: '',
                notes: '',
                chefs: []
            }}
            validationSchema={AddStationWithChefsSchema}
            onSubmit={onSubmit}
            submitLabel="Save"
            loading={loading}
            requiredFields={['name', 'chefs']}
            enableReinitialize
        >
            {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                <>
                    <Box sx={{ mb: '20px' }}>
                        <CustomTypography
                            label="Station Name"
                            sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
                        />
                        <CustomTextField
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            placeholder="Enter Station Name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                        />
                    </Box>

                    <Box sx={{ mb: '20px' }}>
                        <Box className='d-flex align-items-center' sx={{mb:0.5}}>
                            <CustomTypography
                                label="Assign Chefs"
                                sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main, mb:0 }}
                            />
                            <Tooltip title="Add Staff Member" arrow placement="top">
                                <IconButton
                                    size="small"
                                    onClick={() => onAddChef(values)}
                                    sx={{
                                        backgroundColor: theme.palette.primary.main,
                                        color: theme.palette.common.white,
                                        '&:hover': {
                                            backgroundColor: theme.palette.primary.dark,
                                        },
                                        width: 20,
                                        height: 20,
                                        ml: 1
                                    }}
                                >
                                    <AddIcon fontSize="small" sx={{ fontSize: 16 }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <CustomAutocomplete
                            multiple
                            name="chefs"
                            options={chefOptions}
                            value={chefOptions.filter(opt => values.chefs.includes(opt.id))}
                            onChange={(_, newValue) => setFieldValue('chefs', newValue.map(v => v.id))}
                            placeholder={values?.chefs?.length > 0 ? "" : "Select chefs"}
                            error={touched.chefs && Boolean(errors.chefs)}
                            helperText={touched.chefs && errors.chefs}
                            getOptionLabel={(option) => option?.name || ''}
                        />
                    </Box>

                    <Box>
                        <CustomTypography
                            label="Notes"
                            sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
                        />
                        <CustomTextArea
                            name="notes"
                            value={values.notes}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            multiline
                            rows={2}
                            placeholder="Enter Notes"
                        />
                    </Box>
                </>
            )}
        </GenericDialog>
    );
};

export default AddStationWithChefsModal;
